<template>
  <div>
    <QCard class="my-card">
      <QCardSection class="bg-primary text-white">
        <div class="text-h6">Quasar.dev</div>
      </QCardSection>
      <QSeparator dark />
      <QCardSection>Build high-performance VueJS user interfaces in record time</QCardSection>
      <QSeparator dark />
      <QCardActions class="bg-primary text-white">
        <QBtnGroup>
          <QBtn type="a" target="_blank" href="https://quasar.dev" color="secondary">Doc</QBtn>
          <QBtn
            type="a"
            target="_blank"
            href="https://github.com/quasarframework/"
            color="secondary"
          >Guthub</QBtn>
          <QBtn type="a" target="_blank" href="https://forum.quasar.dev" color="secondary">Chat</QBtn>
          <QBtn type="a" target="_blank" href="https://forum.quasar.dev" color="secondary">Forum</QBtn>
          <QBtn
            type="a"
            target="_blank"
            href="https://twitter.com/quasarframework"
            color="secondary"
          >Twitter</QBtn>
        </QBtnGroup>
      </QCardActions>
    </QCard>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import {
  QPage,
  QCard,
  QCardSection,
  QCardActions,
  QBtnGroup,
  QBtn,
  QSeparator,
  QIcon
} from "quasar";

@Component({
  components: {
    QPage,
    QCard,
    QCardSection,
    QCardActions,
    QBtn,
    QBtnGroup,
    QSeparator,
    QIcon
  }
})
export default class Quasar extends Vue {}
</script>

<style lang="sass" scoped>
.my-card
  display: inline-block
  margin: 0.5em
</style>
